export default {
  "settlementPending": "La conferma del pagamento è in attesa. Aggiorna il conto o controlla di nuovo tra poco prima di riprovare.",
  "checkoutOpenFailed": "Impossibile aprire il pagamento sicuro. Riprova.",
  "checkoutClosed": "Il pagamento è stato chiuso. La conferma potrebbe essere ancora in attesa. Controlla il risultato prima di riprovare.",

  "returnToApp": "Torna all’app",
  "dashboard": "Pannello di controllo",
  "account": "Conto",
  "currentBalance": "Saldo attuale",
  "balanceUnavailable": "Saldo non disponibile",
  "balanceLoading": "Caricamento del saldo",
  "lastUpdated": "Ultimo aggiornamento",
  "monthlyBillHelp": "Questi addebiti saranno inclusi nella fattura mensile.",
  "billingPeriod": "Periodo di fatturazione",
  "currentMonth": "Mese corrente",
  "billableItems": "Voci fatturabili",
  "payBalance": "Paga il saldo attuale",
  "settleHelp": "Salda il tuo conto online in modo sicuro.",
  "autoRefreshHelp": "Il saldo verrà aggiornato automaticamente dopo la conferma del pagamento.",
  "retry": "Riprova",
  "noCharges": "Non hai addebiti in corso.",
  "clearHelp": "Il tuo conto è in regola per il periodo di fatturazione corrente.",
  "statementItems": "Voci dell’estratto conto attuale",
  "includedThisMonth": "Incluso nella fattura di questo mese",
  "preparingCheckout": "Preparazione del pagamento sicuro…",
  "paymentsDisabled": "I pagamenti online non sono ancora abilitati per questo club.",
  "paymentsSetup": "Il club sta configurando i pagamenti online.",
  "paymentReceived": "Pagamento ricevuto. Il saldo del tuo conto è aggiornato.",
  "statementUpdating": "Pagamento ricevuto. Il tuo estratto conto è in fase di aggiornamento.",
  "paymentCancelled": "Il pagamento è stato annullato. Non è stato addebitato alcun importo.",
  "allowPopups": "Consenti le finestre popup per aprire il pagamento sicuro in una nuova scheda.",
  "checkoutOpened": "Il pagamento sicuro è stato aperto in una nuova scheda.",
  "checkoutFailed": "Non è stato possibile preparare il pagamento sicuro. Riprova tra poco.",
  "items": "{count} prodotto",
  "itemsMany": "{count} articoli",
  "refreshing": " · Aggiornamento",
  "loadFailed": "Non è stato possibile caricare il saldo. Riprova.",
  "unknownStatus": "Stato non disponibile",
  "noBalanceDue": "Nessun saldo da pagare.",
  "balanceUnconfirmed": "Non è stato possibile confermare il saldo attuale. Aggiorna il tuo conto.",
  "currencyUnavailable": "La valuta del pagamento online non è disponibile. Contatta il club."
}
